module.exports = __webpack_public_path__ + "img/lost.a6459033.svg";